import styled from "styled-components";
import {DARK_GRAY_COLOR} from "../../constants/colors";

const Container = styled.div`
  position: relative;
  max-width: 25rem;
  font-size: .9rem;
  border-radius: 20px;
  margin: 3rem .5rem;
  
  &:first-child {
    margin-top: 1rem;
  }
`;

export const ChatContainer = styled(Container)`
  background-color: #f5f6fa;
  padding: 1rem .75rem 1rem 2.5rem;
`;

export const SelfChatContainer = styled(Container)`
  background-color: var(--accent-color);
  color: #FFF;
  margin-left: auto;
  padding: 1rem 2.5rem 1rem .75rem;
  text-align: right;
`;

export const SenderDetail = styled.div`
  position: absolute;
  left: -20px;
  bottom: -25px;
`;

export const SelfSenderDetail = styled(SenderDetail)`
  right: -20px;
  left: unset;
`;

export const AvatarContainer = styled.div`
  width: 55px;
  height: 55px;
  background-color: var(--main-color);
  border-radius: 50%;
`;

export const Message = styled.p`
  color: var(--default-text-color);
`;

export const Avatar = styled.div`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const Detail = styled.div`
 font-size: .7rem;
  color: ${DARK_GRAY_COLOR};
  align-self: flex-end;
`;

export const NickName = styled.p`
 font-size: .7rem;
  text-align: center;
  position: absolute;
  width: 100%;
  max-width: calc(100% - 10px);
  bottom: -14px;
`;
